import { useSetSelectedRoomState } from "@/shared/client";
import { useQuery } from "@tanstack/react-query";
import { API_RESERVE } from "../apis";
import { QUERY_KEY } from "../keys";

export const useGetReserve = <T>(params: { [key: string]: any }) => {
    const setSelectedRoomState = useSetSelectedRoomState();
    const { data, isLoading } = useQuery({
        queryKey: [QUERY_KEY.GET_RESERVE_INFO, params],
        queryFn: () => API_RESERVE.getRoomList<T>({ ...params }),
        staleTime: 0,
        gcTime: 0,
    });
    if (isLoading && params.checkIn) setSelectedRoomState([]);
    return { data, isLoading };
};
